import React from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { SelectFieldType } from '@/type';
import SelectInput from '@components/common/input/SelectInput';

interface SelectProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  selectField: SelectFieldType;
}

const SelectController = <TFieldValues extends FieldValues = FieldValues>({
  control,
  selectField,
}: SelectProps<TFieldValues>) => {
  return (
    <Controller
      name={selectField.name as any}
      control={control}
      render={({ field, fieldState }) => (
        <SelectInput field={field} selectField={selectField} error={fieldState.error} />
      )}
    />
  );
};
export default SelectController;
